// @flow
import * as React from 'react';
import { dashboardColumns } from './dashboard-columns';
import { NotesRow } from './notes-row';
import { DataGrid, DataGridProps } from '../../../shared';
import { ClientViewListRepresentationOutput, Field } from '@coverright/data-access/types/enrollment';

type Props = Omit<DataGridProps<ClientViewListRepresentationOutput, Field>, 'columns'>;
export const DashboardDataGrid = (props: Props) => {
  return (
    <DataGrid {...props}
              columns={dashboardColumns}
              sx={{
                '& tbody tr td': {
                  verticalAlign: 'top',
                },
                '& tbody tr:nth-of-type(4n+1):not(.info) td, & tbody tr:nth-of-type(4n+2):not(.info) td': {
                  backgroundColor: '#fff',
                  border: 'none',
                  '&:first-of-type': {
                    borderLeft: '1px solid rgb(228, 228, 231)'
                  },
                },
                '& tbody tr:nth-of-type(4n+1):not(.info) td, & tbody tr:nth-of-type(4n+3):not(.info) td': {
                  pt: .5
                },
                '& tbody tr:nth-of-type(4n+2):not(.info) td': {
                  borderBottom: '1px solid rgb(228, 228, 231)'
                },
                '& tbody tr:nth-of-type(4n+3):not(.info) td, & tbody tr:nth-of-type(4n):not(.info) td': {
                  backgroundColor: '#f6f7f7',
                  border: 'none',
                  '&:first-of-type': {
                    borderLeft: '1px solid rgb(228, 228, 231)'
                  },
                },
                '& tbody tr:nth-of-type(4n):not(.info) td': {
                  borderBottom: '1px solid rgb(228, 228, 231)'
                },
              }}
              extraRowBuilder={(row, i) => (
                <NotesRow key={'row_extra' + i} client={row}/>
              )}/>
  );
};
